var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.524 6.476a1.62 1.62 0 011.62 1.62v3.237a1.62 1.62 0 01-3.239 0V8.095a1.62 1.62 0 011.62-1.619v0z",
    stroke: "#9C1A87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.953 9.714h-17.81M8.905 9.714H4.048",
    stroke: "#9C1A87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.524 22.667a1.62 1.62 0 011.62 1.619v3.238a1.619 1.619 0 01-3.239 0v-3.238a1.62 1.62 0 011.62-1.62z",
    stroke: "#9C1A87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.953 25.905h-17.81M8.905 25.905H4.048",
    stroke: "#9C1A87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M23.477 14.571a1.619 1.619 0 011.619 1.62v3.238a1.619 1.619 0 01-3.239 0V16.19a1.62 1.62 0 011.62-1.62v0z",
    stroke: "#9C1A87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.857 17.81H4.047M29.953 17.81h-4.857",
    stroke: "#9C1A87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgFilterIcon;